import { createElement } from 'react';
import { Component } from 'react';
import { observer } from 'mobx-react';
import withStyles, { WithStyles } from 'react-jss';
import { ComponentDesc } from '../../store';
import { settingsPanelStyles as styles } from './styles';

interface IProps extends WithStyles<typeof styles> {
    descriptor: ComponentDesc<any>;
}

class HeightWidthEditor extends Component<IProps, any> {
    render() {
        let { descriptor } = this.props;
        const { classes } = this.props;
        return (
            <div className={classes.root}>
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'flex-start',
                    }}>
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            paddingBottom: 5,
                        }}>
                        <span
                            className={classes.header}
                            style={{ width: 77, marginLeft: 4 }}>
                            {' '}
                            Height{' '}
                        </span>
                        <input
                            type="number"
                            value={descriptor.style.height as number}
                            onChange={(e) =>
                                (descriptor.style.height = +e.target.value)
                            }
                            className={classes.input + ' heightInputBox'}
                        />
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                        }}>
                        <span
                            className={classes.header}
                            style={{ width: 77, marginLeft: 4 }}>
                            {' '}
                            Width{' '}
                        </span>
                        <input
                            type="number"
                            value={descriptor.style.width as number}
                            onChange={(e) =>
                                (descriptor.style.width = +e.target.value)
                            }
                            className={classes.input}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default withStyles(styles)(observer(HeightWidthEditor));
